import { getBuyerToken, getBuyerUser } from "./authStorage";
import { getStorageItem, removeStorageItem, setStorageItem } from "./browser";

export const AUTH_MODAL_EVENT = "elumia:auth-modal";
export const AUTH_RETURN_TO_STORAGE_KEY = "elumia_auth_return_to";

const dispatchAuthModalEvent = (open) => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(AUTH_MODAL_EVENT, {
      detail: { open },
    }),
  );
};

export const openAuthModal = ({ returnTo = "" } = {}) => {
  if (returnTo) {
    setStorageItem(AUTH_RETURN_TO_STORAGE_KEY, returnTo);
  } else {
    removeStorageItem(AUTH_RETURN_TO_STORAGE_KEY);
  }

  dispatchAuthModalEvent(true);
};

export const closeAuthModal = () => {
  dispatchAuthModalEvent(false);
};

export const getAuthReturnTo = () => {
  const value = getStorageItem(AUTH_RETURN_TO_STORAGE_KEY, "");
  return value.startsWith("/") && !value.startsWith("//") ? value : "";
};

export const clearAuthReturnTo = () => {
  removeStorageItem(AUTH_RETURN_TO_STORAGE_KEY);
};

export const getStoredUser = () => {
  return getBuyerUser();
};

export const isUserLoggedIn = () => {
  return Boolean(getBuyerToken() || getStoredUser());
};
